export default "__VITE_ASSET__BsTXms8y__"